import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateEmail extends ValidateDefaults {
    constructor(obj) {
        super(obj);
        this.message = obj.message
            ? obj.message
            : 'Please make sure you enter your entire email address';
        this.on = ['blur'];
        this.pageAttrKey = 'validation_email';
    }

    validate(email) {
        const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(email);
    }

    getMatchingValidationMessage() {
        let hasAt = this.formData.indexOf('@') !== -1;
        let hasPeriod = this.formData.indexOf('.') !== -1;

        if (!hasAt && !hasPeriod) {
            return 'validation_email';
        }
        if (!hasAt) {
            return 'validation_email_no_at';
        }
        if (!hasPeriod) {
            return 'validation_email_no_period';
        }

        return 'validation_email';
    }

    static defaultMessage() {
        return 'Please make sure you enter your entire email address';
    }
}
